import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as g from 'src/app/globals';

@Pipe({
  name: 'productImageUrl'
})
export class ProductImageUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string) {
    if (value === '' || value == null) {
      return 'assets/not-available.jpg';
    }
    if (value.startsWith('http')) {
      return this.sanitizer.bypassSecurityTrustUrl(value);
    } else {
      const filename = value.substring(value.lastIndexOf('/') + 1);
      const encodedFileName = encodeURIComponent(filename);

      value = value.replace(filename, encodedFileName);
      return this.sanitizer.bypassSecurityTrustUrl(
        `${g.apiBaseUrl}media/PreviewFile?path=${value}&${g.getUrlSuffix()}`
      );
    }
  }
}
